import { Brand } from '@stax-core/types-omni';
import { BrandAction, BrandActionType, BrandMCC } from './Brand.types';

export function updateBrand(
  brand: Brand | null,
  brandName: string | null,
  mcc: BrandMCC[] | null,
): BrandAction {
  return {
    type: BrandActionType.UPDATE_BRAND,
    payload: { brand, brandName, mcc },
  };
}

export function removeBrand(): BrandAction {
  return { type: BrandActionType.REMOVE_BRAND };
}
